import api from "../api/axios";
import * as XLSX from "xlsx";

export const fetchReports = async () => {
  const response = await api.get("/reports");
  return response.data;
};

export const deleteReport = async (reportId) => {
  const response = await api.delete(`/reports/${reportId}`);
  return response.data;
};

export const fetchReportById = async (reportId) => {
  const response = await api.get(`/reports/${reportId}`);
  return response.data;
};

export const generateProductReport = async (
  reportStartDate,
  reportEndDate,
  reportName
) => {
  console.log("the function was triggered here inside");
  //The format of date is DD-MM-YYYY
  const startDate = reportStartDate
    .toISOString()
    .split("T")[0]
    .split("-")
    .reverse()
    .join("-");
  const endDate = reportEndDate
    .toISOString()
    .split("T")[0]
    .split("-")
    .reverse()
    .join("-");

  const response = await api.post("/reports", {
    name: reportName,
    startDate: startDate,
    endDate: endDate,
    objectType: "product",
  });
  return response.data;
};

export const handleDownloadReport = async (reportId) => {
  // Generate an excel file with 5 columns: Product, Variant, Quantity
  // The data should be fetched from the reportid
  const report = await fetchReportById(reportId);
  const data = report.details;
  const rows = data.map((item) => ({
    Producto: item.product_name,
    Variante: item.variant_name,
    Cantidad: item.quantity,
  }));
  const aggRows = rows.reduce((acc, row) => {
    const existingItem = acc.find((it) => it.Producto === row.Producto);
    if (existingItem) {
      existingItem.Cantidad += row.Cantidad;
    } else {
      acc.push(row);
    }
    return acc;
  }, []);
  const worksheet = XLSX.utils.json_to_sheet(aggRows);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
  XLSX.writeFile(
    workbook,
    `${report.report_name}_${report.created_at.split("T")[0]}.xlsx`
  );
};
